type EnvShape = {
  apiUrl: string;
  appName: string;
  pinflLength: number;
  pinflMonthlyLimit: number;
};

/**
 * Derive the WebSocket origin from the HTTP API base URL.
 * `http(s)://host:port/api/v1` -> `ws(s)://host:port`. The realtime routes are
 * mounted at the server root (no `/api/v1` prefix), so only origin is kept.
 */
export const getWsOrigin = (apiUrl: string): string => {
  try {
    const url = new URL(apiUrl);
    const proto = url.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${proto}//${url.host}`;
  } catch {
    return '';
  }
};

const required = (key: string, value: string | undefined): string => {
  if (!value || value.length === 0) {
    if (import.meta.env.DEV) console.warn(`[env] missing required ${key}`);
    return '';
  }
  return value;
};

export const env: EnvShape = {
  apiUrl: required('VITE_API_URL', import.meta.env.VITE_API_URL),
  appName: import.meta.env.VITE_APP_NAME ?? 'Japan Cargo · Admin',
  pinflLength: Number(import.meta.env.VITE_PINFL_LENGTH ?? 14),
  pinflMonthlyLimit: Number(import.meta.env.VITE_PINFL_MONTHLY_LIMIT ?? 200),
};
